import script from "./education-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./education-delete-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__